module.exports = __webpack_public_path__ + "img/cupom.cbfcc977.svg";